<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-20 09:21:23
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 15:47:18
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-12 17:22:49
-->
<template>
  <div>
    <el-drawer
      :title="item.id?'编辑模型':'新增模型'"
      :visible.sync="visibleTwo"
      @close="closeDra"
      :size="width<=720?'90%':'500px'"
      :with-header="true"
      class="box"
      :wrapperClosable="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-width="width<=720?'120px':'100px'"
        class="demo-ruleForm"
      >
        <el-form-item label="模型类型" prop="modelType">
          <el-select v-model="ruleForm.modelType" placeholder="请选择模型类型">
            <el-option label="全站模型" value="0"></el-option>
            <el-option label="本站模型" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模型名称" prop="modelName">
          <el-input
            v-model="ruleForm.modelName"
            placeholder="请输入模型名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联模板" prop="templatePath">
          <el-input
            placeholder="内容页的模板文件"
            v-model="ruleForm.templatePath"
           disabled
          >
            <template slot="append"
              ><span @click="chooseTemplate" class="select-model"
                >选择模板</span
              ></template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <div class="status">
            <el-radio v-model="ruleForm.state" label="0">启用</el-radio>
            <el-radio v-model="ruleForm.state" label="1">停用</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="4"
            v-model="ruleForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="btnShow" class="bottom">
          <div class="form-bottom">
            <el-button
              style="padding: 10px 24px"
              size="small"
              @click="closeDra"
              >取消</el-button
            >
            <el-button
              style="padding: 10px 24px"
              size="small"
              type="primary"
              @click="submit"
               :loading="loading"
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-drawer>
    <!-- 选择模板 -->
    <div class="choose_template">
      <el-dialog width="700px" title="选择模板" :visible.sync="templateIsShow">
        <div class="lod-tips">
          <span>I</span>
          模板只能选择.csshtml后缀的文件，点击文件夹图标可进入下级目录
        </div>
        <div class="choose-path model-name">
            <span
              @click="returnParent(templateList.directoryPath)"
              class="icon-arrow-back back-box"
            ></span> /{{ templateList.directoryPath }}
        </div>
        <div class="template-list">
          <div class="title item">名称</div>
          <div class="list-box">
              <div
                class="item model-name"
                v-for="(
                  item, index
                ) in templateList.templateDirectoryAndFileResponse"
                :key="index"
                @click="getTemplates(item.isDir, item.name, item.allPath,2)"
              >
                <span>{{ item.name }}</span>
              </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getTemplateList,create,update } from "./substance_model_management";
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
export default {
  data() {
    return {
      ruleForm: {
        modelName: "",
        modelType: "0",
        templatePath: "",
        state: "0",
        remark: "",
      },
      loading:false,
      rules: {
        modelName: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        modelType: [{ required: true, message: "请选择模板类型", trigger: "change" }],
        templatePath: [{ required: true, message: "请选择关联模板", trigger: "blur" }],
        state: [{ required: true, message: "请选择模板状态", trigger: "blur" }],
       
      },
      templateIsShow: false,
      templateList: {},
      visibleTwo:false,
      width:'',
      btnShow:true,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item:{
       type: Object,
      default: ()=>{
        return {}
      },
    }
  },
  watch:{
    visible(){
      this.visibleTwo = this.visible;
      this.width  = document.documentElement.clientWidth;
      this.getKeyboardState()
       window.onresize = () => {
          return (() => {
             this.width  = document.documentElement.clientWidth;
          })();
        };
      if(this.visible){
          if(this.item.id){
              this.ruleForm.modelName = this.item.modelName;
              this.ruleForm.modelType = `${this.item.modelType}`;
              this.ruleForm.templatePath = this.item.templatePath;
              this.ruleForm.state = `${this.item.state}`;
              this.ruleForm.remark = this.item.remark;
              this.ruleForm.id = this.item.id;
          }else{
            this.ruleForm = {
               modelName: "",
                modelType: "0",
                templatePath: "",
                state: "0",
                remark: "",
            }
          }
          this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
      this.$refs.ruleForm.clearValidate();
    },
     getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    closeDra(){
      this.$emit("closeDra");
      this.$refs.ruleForm.clearValidate();
    },
    submit(){
      this.loading = true;
      this.$refs.ruleForm.validate((valid) => {
      if (valid) {
          if(this.item.id){
           update({...this.ruleForm,siteId:sessionStorage.getItem('siteId')}).then((res)=>{
            if(res.code == 0){
                this.close();
            }
             this.loading = false;
        }) 
        }else{
           create({...this.ruleForm,siteId:sessionStorage.getItem('siteId')}).then((res)=>{
            if(res.code == 0){
                this.close();
            }
            this.loading = false;
        }) 
        }
      } else {
          this.loading = false;
      }
      })
        
        
    },
    returnParent(directoryPath) {
      let path = directoryPath.substring(
        0,
        directoryPath.lastIndexOf("/", directoryPath.lastIndexOf("/") - 1) + 1
      );
      if (path) {
        this.getTemplates(true, "", path, 2);
      }
    },
    // 选择模板
    chooseTemplate() {
      const _this = this;
      _this.templateIsShow = true;
      _this.getTemplates(true);
    },
    getTemplates(isDir, fileName = "", path = "",isFile=1) {
      const _this = this;
      if (isDir) {
        let reqData = {
          fileName: fileName,
          path: path,
          siteId: sessionStorage.getItem('siteId'),
          type: isFile,
          isHtml:true,
        };
        getTemplateList(reqData).then((res) => {
          if (res.code == 0) {
            _this.templateList = res.data;
          }
        });
      } else {
         let allPath = path.substring(path.indexOf("/") + 1, path.length);
        _this.ruleForm.templatePath = allPath;
        _this.templateIsShow = false;
      }
    },
  },
  created() {
   
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 60px;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 18px;
    font-weight: bold;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;
  .list-box{
                height: 450px;
                overflow-y: auto;
            }
    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      cursor: pointer;
      &:last-child {
        border: none;
      }
    }
  }
  .model-name {
    cursor: pointer;
  }
}
.select-model {
  cursor: pointer;
}
.el-button--primary {
  background: #176de6;
}
</style>